export default "__VITE_ASSET__DHplTV_x__"